import { Component } from '@angular/core';

@Component({
  selector: 'app-accessdenied',
  templateUrl: './app.accessdenied.component.html',
  styleUrls: ['./app.accessdenied.component.scss'],
})
export class AppAccessdeniedComponent {
  year = new Date().getFullYear();
}
